import { render } from "./fullscreenVideo.vue?vue&type=template&id=2d4f87a3"
import script from "./fullscreenVideo.vue?vue&type=script&lang=js"
export * from "./fullscreenVideo.vue?vue&type=script&lang=js"

import "./fullscreenVideo.vue?vue&type=style&index=0&id=2d4f87a3&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__